import React from "react";
import ArtistService from "../apis/artist";
import ArtistItem from "./ArtistItem";

class ArtistList extends React.Component {
    state = {
        artists: []
    };
    
    componentDidMount() {
        this.fetchArtists();
    };

    async fetchArtists() {
        const response = await ArtistService.getArtists();
        this.setState({artists: response.data});
    };


// TODO: render VideoItem Thumbnail and implement a function that loads individual Videos on click of user
    renderedList = () => {
        return this.state.artists.map((artist) => {
            return <ArtistItem
                key={artist.id}
                artistId={artist.id}/>;
        })
    };
    render() {
            return (
                <div className="container ui">
                    {this.renderedList()}
                </div>
            )
        }

}

export default ArtistList;
